export function doBlockPage(otherMessage) {
    const message = otherMessage || 'Пожалуйста подождите. Идет обработка данных.';
    $('body').append(`${'<div id="disable-all">'
        + '<div class="modal-backdrop fade in" style="z-index: 99998;"></div>'
        + '<div class="modal fade in" tabindex="-1" style="z-index: 99999; display: block;"'
        + 'role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">'
        + '<div class="modal-dialog"><div class="modal-content"><div class="modal-body">'
        + '<span class="text-center text-danger">'}${message}</span>`
        + '</div></div></div></div></div>');
}

export function doUnblockPage() {
    $('body').find('#disable-all').remove();
}
